import InquirySummary from "./InquirySummary";

export default InquirySummary;
